// extracted by mini-css-extract-plugin
export var danger = "_3n-6";
export var lightPink = "_3n-a";
export var medium = "_3n-j";
export var nearSquare = "_3n-m";
export var neutralBlue = "_3n-8";
export var neutralYellow = "_3n-7";
export var noCapitalize = "_3n-1";
export var normal = "_3n-2";
export var pill = "_3n-0";
export var primary = "_3n-3";
export var primaryLight = "_3n-4";
export var shadow = "_3n-n";
export var small = "_3n-k";
export var solidBlack = "_3n-i";
export var solidGreen = "_3n-d";
export var solidLightBlue = "_3n-f";
export var solidNavy = "_3n-e";
export var solidOrange = "_3n-h";
export var solidPink = "_3n-g";
export var solidRed = "_3n-b";
export var solidWhite = "_3n-9";
export var solidYellow = "_3n-c";
export var success = "_3n-5";
export var xsmall = "_3n-l";